import { SliderBase } from './SliderBase';

class SliderNavigation {
	private readonly buttonPrev: HTMLButtonElement;
	private readonly buttonNext: HTMLButtonElement;

	constructor(instance: SliderBase) {
		this.buttonPrev = instance.config.target.parentNode.querySelector('button.prev');
		this.buttonNext = instance.config.target.parentNode.querySelector('button.next');

		if (this.buttonPrev && this.buttonNext) {
			this.buttonPrev.addEventListener('click', () => instance.prevItem());
			this.buttonNext.addEventListener('click', () => instance.nextItem());
		}
	}

	public updateNavigation(prevEnabled: boolean, nextEnabled: boolean): void {
		if (this.buttonPrev && this.buttonNext) {
			this.buttonPrev.disabled = !prevEnabled;
			this.buttonNext.disabled = !nextEnabled;
		}
	}
}

export { SliderNavigation };
